Object.defineProperty(exports, "__esModule", {
  value: true
});
// from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-autocomplete
// see also:
//  - https://developers.google.com/web/fundamentals/design-and-ui/input/forms/#use_metadata_to_enable_auto-complete
//  - https://cloudfour.com/thinks/autofill-what-web-devs-should-know-but-dont/
var autoCompleteTypes = ['name', 'honorific-prefix', 'given-name', 'additional-name', 'family-name', 'honorific-suffix', 'nickname', 'email', 'username', 'new-password', 'current-password', 'organization-title', 'organization', 'street-address', 'address-line1', 'address-line2', 'address-line3', 'address-level4', 'address-level3', 'address-level2', 'address-level1', 'country', 'country-name', 'postal-code', 'cc-name', 'cc-given-name', 'cc-additional-name', 'cc-family-name', 'cc-number', 'cc-exp', 'cc-exp-month', 'cc-exp-year', 'cc-csc', 'cc-type', 'transaction-currency', 'transaction-amount', 'language', 'bday', 'bday-day', 'bday-month', 'bday-year', 'sex', 'tel', 'url', 'photo'];

exports['default'] = autoCompleteTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/constants/autoCompleteTypes.js
// module id = 404
// module chunks = 923280921217